import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Stack, Tooltip, Typography } from '@mui/material';
import { Lock } from '@mui/icons-material';

/**
 * Marca de dato protegido por k-anonymity. Nunca se deja una celda gris muda: siempre va el
 * candado con su explicación (grupo de menos de 5 personas) para que la empresa entienda que
 * es una garantía de privacidad y no un error de la app.
 */
function ProtectedBadge({ compact = false }) {
  const { t } = useTranslation(['orgClient']);
  const label = t('privacy.protected', { defaultValue: 'Protegido por privacidad' });
  const reason = t('privacy.protectedReason', {
    defaultValue: 'Se necesitan al menos 5 respuestas para mostrar un dato. Con menos gente, alguien podría ser identificado.'
  });

  if (compact) {
    return (
      <Tooltip title={`${label}. ${reason}`}>
        {/* titleAccess y no aria-label: MUI marca el ícono como aria-hidden salvo que lleve
            título, y este candado ES la información de la celda. */}
        <Lock titleAccess={label} sx={{ fontSize: 14, color: 'text.disabled' }} />
      </Tooltip>
    );
  }

  return (
    <Tooltip title={reason}>
      <Stack direction="row" spacing={0.75} alignItems="center" sx={{ color: 'text.disabled' }}>
        <Lock sx={{ fontSize: 15 }} />
        <Typography variant="caption" sx={{ fontWeight: 700 }}>
          {label}
        </Typography>
      </Stack>
    </Tooltip>
  );
}

ProtectedBadge.propTypes = {
  /** Solo el candado (celdas del mapa por departamento, donde no cabe el texto). */
  compact: PropTypes.bool
};

export default ProtectedBadge;
